/**
 * Icon registry context (ADR-025).
 *
 * Provides a React context for the icon registry, allowing
 * JacquardIconProvider to override individual intent mappings
 * without modifying the static registry.
 *
 * Lives in `src/icons/` to avoid a circular dependency between
 * the icons module and the kit module.
 */

import { createContext, useContext } from 'react';
import { ICON_REGISTRY } from './registry';

export const JacquardIconContext = createContext<typeof ICON_REGISTRY>(ICON_REGISTRY);

export function useIconRegistry(): typeof ICON_REGISTRY {
  return useContext(JacquardIconContext);
}
